<template>
  <div class="average-life gray-bar-top app">
    <h3 class="app-title">
      Average Life Breakdown
    </h3>
    <blue-table :module-data="{data: avgLifeData, includeDataField: true}" />
    <div class="sub-info">
      % of net assets as of {{ setAsOfDate(avgLifeData) }} (updated quarterly).
    </div>
  </div>
</template>

<script>
import BlueBarTable from '_components_/global/BlueBarTable';
export default {
	name: 'AverageLifeModule',
	components: {
		'blue-table': BlueBarTable
	},
	props: {
		avgLifeData: {
			type: Array,
			defult: null
		}
	},
	watch: {
		avgLifeData: {
			immediate: true,
			handler(val) {
				this.$EventBus.$emit('ExcelData', 'AverageBreakdownModule', val);
			}
		}
	},
	methods: {
		setAsOfDate(array) {
			return array[0] && array[0].DataAsOfDate
				? array[0].DataAsOfDate
				: '--';
		}
	}
};
</script>

<style lang="less" scoped>
	.average-life {
		color: #333;
		font-family: 'AvenirNextLTW01-Regular', Arial, serif;
		font-size: 14px;
		.table-list {
			list-style-type: none;
			margin: auto;
			padding: 0;
			li {
				border-bottom: 1px solid #ccc;
				display: inline-block;
				line-height: 22px;
				padding-right: 10px;
				width: 100%;
				margin-bottom: 0;
				.data {
					float: right;
					max-width: 10%;
				}
			}
			.top-border {
				border-top: 1px solid #ccc;
				height: 23px;
			}
			.blue-bar {
				background-color: #f2fafd;
				display:inline-block;
				height: 21px;
				padding-left: 10px;
				white-space: nowrap;
			}
		}
		.sub-info {
			margin-top: 10px;
		}
	}
</style>

